export enum ClientType {
  expedition = 'expedition',
  direct = 'direct',
  carrier = 'carrier',
}

export enum ClientPaymentTerms {
  original = 'original',
  scan = 'scan',
}
